<script setup>
import {computed} from "vue";
import {useNotificationStore} from "@/stores/notifications.js";

const notificationStore = useNotificationStore();

const props = defineProps({
  notification: {
    type: Object,
    required: true,
  },
});

const messageIcon = computed(() => {
  switch(props.notification.type) {
    case 'loader':
      return 'fa-gear';
    case 'success':
      return 'fa-circle-check';
    case 'error':
      return 'fa-circle-exclamation';
    default:
      return 'fa-circle-info';
  }
});

const notificationStyle = {
  'animation': props.notification.type !== 'loader'
    ? `fade-out 0.5s ease-in-out ${props.notification.duration - 0.5}s 1 forwards, fade-in 0.5s ease-in-out`
    : ''
}
</script>

<template>
  <div class="text-neutral-200 mt-3 shadow rounded overflow-hidden w-100 relative"
       :class="{
         'bg-gray-700': notification.type === 'default' || notification.type === 'loader',
         'bg-orange-700': notification.type === 'error',
         'bg-green-700': notification.type === 'success'
       }"
       :style="notificationStyle">
    <div v-if="notification.type !== 'loader'"
         class="bg-gray-900 h-2"
         :class="{
           'bg-gray-900': notification.type === 'default',
           'bg-orange-900': notification.type === 'error',
           'bg-green-900': notification.type === 'success'
         }"
         :style="{'animation': `reduce-width ${notification.duration}s linear 0s 1 forwards`}">
    </div>
    <div class="py-6 px-8 flex">
      <div class="flex-none w-6">
        <font-awesome-icon :icon="['fas', messageIcon]" :spin="notification.type === 'loader'"/>
      </div>
      <p class="flex-grow-1">{{ notification.text }}</p>
    </div>
    <font-awesome-icon v-if="notification.type !== 'loader'"
                       class="absolute top-2 right-2 cursor-pointer"
                       @click="notificationStore.removeNotification(notification)"
                       :icon="['fas', 'fa-times']"/>
  </div>
</template>
